'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import type { ChatbotFeatureFlag } from 'oldchatbot/types/ChatbotFeatureFlag'
import { ChatbotButton as OldChatbotButton } from '../ChatbotButton/ChatbotButton'

export const ChatbotContainer = () => {
	const { enabled: isChatbotEnabled, variables: chatbotVariables } =
		useFeatureFlag<ChatbotFeatureFlag>(featureFlagKeys.Chatbot)
	const { chatbotVersion } = chatbotVariables ?? {}

	const isChatbotRedesign = chatbotVariables?.chatbotRedesign

	if (!isChatbotEnabled || isChatbotRedesign) {
		return null
	}

	return <OldChatbotButton version={chatbotVersion} />
}
